var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ac5f9d6c6bf831471adb6f3de63656e76d23939c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app-service@coverdash"]={id:"ac5f9d6c6bf831471adb6f3de63656e76d23939c"};
      